/*
 * @Descripttion:
 * @version:
 * @Author: 邓旭阳
 * @Date: 2022-01-17 10:02:27
 * @LastEditors: HGcth66 HGcth66@163.com
 * @LastEditTime: 2025-08-14 14:45:59
 */
import Environment from "./Environment";
// const LOGIN_HEADER = '';
// const BigDataIframeSrc = '';
// const PAY_HEADER = '';

export default {
  // 用户接口
  getTreeData: Environment.USER_HEADER + "/department/query",
  getTableData: Environment.USER_HEADER + "/user/query",
  // 图片上传
  imageUpload: Environment.IMG_HEADER + "/presignedUrl?sysName=emercontrol",
  removeImageUpload: Environment.IMG_HEADER + "/removeUploadFile?sysName=emercontrol",

  // 预案接口
  UpdataPlanstatus: Environment.PLAN_HEADER + "/planstatus/update",

  // 任务接口
  getdetail: Environment.API_HEADER + "/task/querydetail",
  getTaskData: Environment.API_HEADER + "/task/query",
  addTaskData: Environment.API_HEADER + "/task/add",
  modifyTaskData: Environment.API_HEADER + "/task/modify",
  deleteTaskData:Environment.API_HEADER + "/task/delete",
  clearTaskData: Environment.API_HEADER + "/task/clear",
  getTasktypeData: Environment.API_HEADER + "/tasktype/query",
  addTasktypeData: Environment.API_HEADER + "/tasktype/add",
  modifyTasktypeData: Environment.API_HEADER + "/tasktype/modify",
  deleteTasktypeData: Environment.API_HEADER + "/tasktype/delete",
  completeTask:Environment.API_HEADER+"/task/complete",
  activeTask:Environment.API_HEADER+"/task/active",

  // 巡检计划
  queryInspection: Environment.API_HEADER + "/task/inspection/query",
  addInspection: Environment.API_HEADER + "/task/inspection/add",
  deleteInspection: Environment.API_HEADER + "/task/inspection/delete",
  updateInspection: Environment.API_HEADER + "/task/inspection/update",
  createInspectionTask: Environment.API_HEADER + "/task/inspection/createtask",
  // 巡检档案
  queryInspectionrecord: Environment.API_HEADER + "/task/inspectionrecord/query",
  deleteInspectionrecord: Environment.API_HEADER + "/task/inspectionrecord/delete",
  updateInspectionrecord: Environment.API_HEADER + "/task/inspectionrecord/update",
  // 巡更计划
  queryPatrolplan: Environment.API_HEADER + "/task/patrolplan/query",
  addPatrolplan: Environment.API_HEADER + "/task/patrolplan/add",
  deletePatrolplan: Environment.API_HEADER + "/task/patrolplan/delete",
  updatePatrolplan: Environment.API_HEADER + "/task/patrolplan/update",
  createPatrolplanTask: Environment.API_HEADER + "/task/patrolplan/createtask",
  // 巡更点
  queryPatrol: Environment.API_HEADER + "/task/patrol/query",
  addPatrol: Environment.API_HEADER + "/task/patrol/add",
  deletePatrol: Environment.API_HEADER + "/task/patrol/delete",
  updatePatrol: Environment.API_HEADER + "/task/patrol/update",
  // 巡更记录
  queryPatrolrecord: Environment.API_HEADER + "/task/patrolrecord/query",
  // 设备类别
  queryEquipmenttype: Environment.API_HEADER + "/task/equipmenttype/query",
  addEquipmenttype: Environment.API_HEADER + "/task/equipmenttype/add",
  deleteEquipmenttype: Environment.API_HEADER + "/task/equipmenttype/delete",
  // 设备
  queryEquipment: Environment.API_HEADER + "/task/equipment/query",
  addEquipment: Environment.API_HEADER + "/task/equipment/add",
  deleteEquipment: Environment.API_HEADER + "/task/equipment/delete",
  updateEquipment: Environment.API_HEADER + "/task/equipment/update",

  queryUserCenterInfo: Environment.API_HEADER + "/task/usercenterinfo/query",
  



  // 工作流接口
  getWorkflowData: Environment.FLOW_HEADER + "/workflow/query",
  getworkflowNodeData: Environment.FLOW_HEADER + "/workflowNode/query",
};
